import * as React from 'react';
import { Segment } from "@independent-software/typeui/controls/Segment";
import { format, parse } from "date-fns";
import { Number } from '@independent-software/typeui/formatters/Number';
import { Label } from '@independent-software/typeui/controls/Label';
import { Flex } from '@independent-software/typeui/controls/Flex';

const CustomTooltip = ({ active, payload, label, parameter }: any) => {
  if(active && payload && payload.length) {
    return <>
      <Segment tight attached="top" secondary>
        {format(parse(label, "t", new Date()), "d MMM yyyy")}
      </Segment>
      <Segment attached>
        {parameter.name}
      </Segment>
      <Segment attached="bottom">
        {payload.map((p:any, idx:number) => 
          <div key={idx}>
            <Label color={p.color}>{p.name}</Label>
            <Label basic><Number value={p.payload.value} decimals={parameter.decimals}/> {parameter.unit}</Label>
          </div>
        )}
      </Segment>
    </>
  }
  return null;
}

export { CustomTooltip }